import { render, staticRenderFns } from "./DemographicsPhone.vue?vue&type=template&id=23326be6&scoped=true"
import script from "./DemographicsPhone.vue?vue&type=script&lang=js"
export * from "./DemographicsPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23326be6",
  null
  
)

export default component.exports